// eslint-disable-next-line import/prefer-default-export
export const ESTATES = {
  GET_ESTATE_EDIT_DETAIL: 'GET_ESTATE_EDIT_DETAIL',
  GET_ESTATE: 'GET_ESTATE',
  GET_ESTATE_SELLER: 'GET_ESTATE_SELLER',
  GET_ESTATE_EXHIBIT_SELLER: 'GET_ESTATE_EXHIBIT_SELLER',
  GET_ESTATE_PROPERTIES: 'GET_ESTATE_PROPERTIES',
  GET_ESTATE_RECOMMEND: 'GET_ESTATE_RECOMMEND',
  VALIDATE_ESTATE_UPDATE_RES: 'VALIDATE_ESTATE_UPDATE_RES',
  SAVE_ESTATE_CREATE: 'SAVE_ESTATE_CREATE',
  GET_ESTATE_DETAIL: 'GET_ESTATE_DETAIL',
  GET_ESTATE_ITEM_VALUE: 'GET_ESTATE_ITEM_VALUE',
  GET_ESTATE_TOTAL: 'GET_ESTATE_TOTAL',
  GET_ESTATE_CREATE_CONFIRM_ACTION: 'GET_ESTATE_CREATE_CONFIRM_ACTION',
  ESTATE_CREATE_RESPONSE: 'ESTATE_CREATE_RESPONSE',
  GET_FAVORITE: 'GET_FAVORITE',
  CREATE_SERVER_ERROR: 'CREATE_SERVER_ERROR',
  CREATE_SERVER_SUCCESS: 'CREATE_SERVER_SUCCESS',
  SET_COMPANIES_TRAIN_LINE: 'SET_COMPANIES_TRAIN_LINE',
  SET_TRAIN_LINE_STATION: 'SET_TRAIN_LINE_STATION',
  SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
  UPDATE_FAVORITE: 'UPDATE_FAVORITE',
  SET_QUICK_SEARCH_TOTAL: 'SET_QUICK_SEARCH_TOTAL',
  LIST_ESTATE_USER: 'LIST_ESTATE_USER',
  SAVE_ESTATE_EXHIBIT_STEP_1: 'SAVE_ESTATE_EXHIBIT_STEP_1',
  UPDATE_ESTATE_SELLER: 'UPDATE_ESTATE_SELLER',
  UPDATE_STATUS: 'UPDATE_STATUS',
  RESET_ESTATE_CRETATE: 'RESET_ESTATE_CRETATE',
};

export const AUTH = {
  LOGIN: 'LOGIN',
  SET_IS_LOGIN: 'SET_IS_LOGIN',
  REGISTER: 'REGISTER',
  SET_REGISTER_DATA: 'SET_REGISTER_DATA',
  ZIP_CODE: 'ZIP_CODE',
  CONFIRM_REGISTER: 'CONFIRM_REGISTER',
  LOGOUT: 'LOGOUT',
};

export const EDIT_PASSWORD = {
  EDIT_PASSWORD: 'EDIT_PASSWORD',
  ALERT_EDIT_PASSWORD_CHANGE: 'ALERT_EDIT_PASSWORD_CHANGE',
};

export const MAINTAINCE = {
  MAINTAINCE: 'MAINTAINCE',
};

export const COMMONS = {
  GET_CATEGORY_MASTER: 'GET_CATEGORY_MASTER',
  GET_RAILWAY_CORPORATION: 'GET_RAILWAY_CORPORATION',
  GET_TRAIN_LINE_CORPORATION: 'GET_TRAIN_LINE_CORPORATION',
  GET_COUNT_OF_ESTATE: 'GET_COUNT_OF_ESTATE',
  SET_SHOW_SIDE_MENU: 'SET_SHOW_SIDE_MENU',
  SET_IS_MOBILE: 'SET_IS_MOBILE',
  GET_LICENSE_NUMBER_FIRST: 'GET_LICENSE_NUMBER_FIRST',
  GET_LIST_PREFECTURES: 'GET_LIST_PREFECTURES',
  GET_YEAR_JAPAN: 'GET_YEAR_JAPAN',
  SET_CITIES: 'SET_CITIES',
  SET_DISTRICTS: 'SET_DISTRICTS',
  CHECK_PERMISSION: 'CHECK_PERMISSION',
  SET_IS_LOADING: 'SET_IS_LOADING',
};

export const USERS = {
  GET_USER_INFO: 'GET_USER_INFO',
  UPLOAD_STAMP_IMAGE: 'UPLOAD_STAMP_IMAGE',
  CHECK_VALIDATE_BASIC_INFO: 'CHECK_VALIDATE_BASIC_INFO',
  UPDATE_BASIC_INFO: 'UPDATE_BASIC_INFO',
  GET_USER_PERMISSION: 'GET_USER_PERMISSION',
  GET_DESTINATION_INFO: 'GET_DESTINATION_INFO',
  CONFIRM_DESTINATION_INFO_DATA: 'CONFIRM_DESTINATION_INFO_DATA',
  CONFIRM_DESTINATION_INFO: 'CONFIRM_DESTINATION_INFO',
  ALERT_DESTINATION_INFO_CHANGE: 'ALERT_DESTINATION_INFO_CHANGE',
  CREATE_SERVER_ERROR: 'CREATE_SERVER_ERROR',
};

export const ADS_INFO = {
  GET_ADS_INFO: 'GET_ADS_INFO',
};

export const NEWS = {
  GET_NEWS: 'GET_NEWS',
  GET_NEWS_DETAIL: 'GET_NEWS_DETAIL',
  GET_NEWS_TAB: 'GET_NEWS_TAB',
  PAGE_PREVIOUS: 'PAGE_PREVIOUS',
  GET_ALL_NEWS: 'GET_ALL_NEWS',
};

export const BANNER = {
  GET_BANNER: 'GET_BANNER',
  BANNER_CLICK_HISTORY: 'BANNER_CLICK_HISTORY',
  BANNER_IMPRESSION_HISTORY: 'BANNER_IMPRESSION_HISTORY',
};

export const ADVERTISING = {
  ADVERTISING_IMPRESSION_HISTORY: 'ADVERTISING_IMPRESSION_HISTORY',
  GET_ADVERTISING: 'GET_ADVERTISING',
  ADVERTISING_CLICK_HISTORY: 'ADVERTISING_CLICK_HISTORY',
  ADVERTISING_OPTION: 'ADVERTISING_OPTION',
  ALL_ADVERTISING_SECTION: 'ALL_ADVERTISING_SECTION',
  GET_INFO_ADVERTISING_SECTION: 'GET_INFO_ADVERTISING_SECTION',
  GET_ADVERTISEMENT_SEARCH: 'GET_ADVERTISEMENT_SEARCH',
  GET_ADVERTISEMENT_TOP_OF_SEARCH: 'GET_ADVERTISEMENT_TOP_OF_SEARCH',
};

export const FORGOT_PASSWORD = {
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  VERIFY_FORGOT_PASSWORD: 'VERIFY_FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
};

export const PREFECTURES = {
  GET_PREFECTURE: 'GET_PREFECTURE',
};

export const SUB_ACCOUNT = {
  FORM_WHERE: 'FORM_WHERE',
  ALERT: 'ALERT',
  GET_LIST: 'GET_LIST',
  GET_DETAIL: 'GET_DETAIL',
  UPDATE_RES: 'UPDATE_RES',
  CREATE_RES: 'CREATE_RES',
  DELETE_RES: 'DELETE_RES',
  ALERT_SUB_ACCOUNT_CHANGE: 'ALERT_SUB_ACCOUNT_CHANGE',
  COUNT_SUB_ACCOUNT: 'COUNT_SUB_ACCOUNT',
  SET_DISABLE: 'SET_DISABLE',
};

export const DESTINATION_INFO = {
  GET_DESTINATION_INFO: 'GET_DESTINATION_INFO',
  CONFIRM_DESTINATION_INFO_DATA: 'CONFIRM_DESTINATION_INFO_DATA',
  CONFIRM_DESTINATION_INFO: 'CONFIRM_DESTINATION_INFO',
  ALERT_DESTINATION_INFO_CHANGE: 'ALERT_DESTINATION_INFO_CHANGE',
  CREATE_SERVER_ERROR: 'CREATE_SERVER_ERROR',
};

export const REGISTER = {
  VERIFY_EMAIL_REGISTER: 'VERIFY_EMAIL_REGISTER',
  RE_SEND_EMAIL: 'RE_SEND_EMAIL',
  REGISTER_VALIDATE: 'REGISTER_VALIDATE',
  RESET_DATA: 'RESET_DATA',
  CLEAR_USER_INFO: 'CLEAR_USER_INFO',
};

export const SEARCH_FAVORITE = {
  SEARCH_CONDITION: 'SEARCH_CONDITION',
  SAVE_CONDITION: 'SAVE_CONDITION',
  DELETE_CONDITION: 'DELETE_CONDITION',
};

export const INQUIRY = {
  SET_INQUIRY_CATEGORIES: 'SET_INQUIRY_CATEGORIES',
  SAVE_INQUIRY: 'SAVE_INQUIRY',
};

export const USAGE_DETAIL = {
  GET_USAGE_DETAIL: 'GET_USAGE_DETAIL',
};

export const RATING_DETAIL = {
  GET_RATING_DETAIL: 'GET_RATING_DETAIL',
  GET_RATING_DETAIL_SELLER: 'GET_RATING_DETAIL_SELLER',
};

export const MONTHLY_PLAN = {
  GET_LIST_MONTHLY_PLAN: 'GET_LIST_MONTHLY_PLAN',
};

export const NOTIFICATIONS = {
  GET_ALL_NOTIFICATIONS: 'GET_ALL_NOTIFICATIONS',
  GET_UNREAD_NOTIFICATIONS: 'GET_UNREAD_NOTIFICATIONS',
  GET_TOTAL_UNREAD_NOTIFICATIONS: 'GET_TOTAL_UNREAD_NOTIFICATIONS',
  REMOVE_NOTIFICATIONS: 'REMOVE_NOTIFICATIONS',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  UNDO_NOTIFICATION: 'UNDO_NOTIFICATION',
  CLEAR_DATA_NOTIFICATIONS: 'CLEAR_DATA_NOTIFICATIONS',
  CLEAR_LIST_NOTIFICATIONS: 'CLEAR_LIST_NOTIFICATIONS',
  RECEIVE_NEW_NOTIFICATION: 'RECEIVE_NEW_NOTIFICATION',
  SEND_NOTIFICATION_TO_USER: 'SEND_NOTIFICATION_TO_USER',
};

export const OPTION = {
  GET_OPTION: 'GET_OPTION',
  POST_OPTION: 'POST_OPTION',
};

export const VIOLATION_REPORT = {
  GET_ALL_VIOLATION_REPORT_CATEGORY: 'GET_ALL_VIOLATION_REPORT_CATEGORY',
  GET_FORM_VIOLATION_REPORT: 'GET_FORM_VIOLATION_REPORT',
  CREATE_VIOLATION_REPORT: 'CREATE_VIOLATION_REPORT',
  CLEAR_FORM_VIOLATION_REPORT: 'CLEAR_FORM_VIOLATION_REPORT',
};

export const FAQ = {
  GET_FAQ_LIST: 'GET_FAQ_LIST',
};

export const BIDDING_HISTORY = {
  GET_LIST_BIDDING_HISTORY: 'GET_LIST_BIDDING_HISTORY',
  GET_LIST_BIDDING_HISTORY_SELLER: 'GET_LIST_BIDDING_HISTORY_SELLER',
};
export const EVENT_WON_BID = {
  GET_EVENT_WON_BID_LIST: 'GET_EVENT_WON_BID_LIST',
};
export const QUESTION_AND_ANSWER = {
  GET_LIST_QUESTION_AND_ANSWER: 'GET_LIST_QUESTION_AND_ANSWER',
  POST_QUESTION: 'POST_QUESTION',
  POST_ANSWER: 'POST_ANSWER',
  DELETE_QUESTION: 'DELETE_QUESTION',
  DELETE_ANSWER: 'DELETE_ANSWER',
  CLEAR_DATA_QUESTION: 'CLEAR_DATA_QUESTION',
  QUESTION_ANSWER_VALIDATE: 'QUESTION_ANSWER_VALIDATE',
  CLEAR_DATA_ANSWER: 'CLEAR_DATA_ANSWER',
  ANSWER_ANSWER_VALIDATE: 'ANSWER_ANSWER_VALIDATE',
};

export const EVENT_SOCKET = {
  EVENT_SEND_MESSAGE: 'SEND_MESSAGE',
  EVENT_GET_MESSAGE: 'GET_MESSAGE',
  EVENT_JOIN_CHANNEL: 'JOIN_CHANNEL',
  EVENT_UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  EVENT_LEAVE_CHANNEL: 'LEAVE_CHANNEL',
  EVENT_FIND_ALL_CHANNEL: 'FIND_ALL_CHANNEL',
  EVENT_FIND_CHANNEL: 'FIND_CHANNEL',
  EVENT_UPDATE_STATUS_CHANNEL: 'UPDATE_STATUS',
  EVENT_CREATE_CHANNEL: 'CREATE_CHANNEL',
  EVENT_JOIN_MESSAGE: 'JOIN_MESSAGE',
  EVENT_UPDATE_STATUS: 'UPDATE_STATUS',
  EVENT_UPDATE_CHANNEL: 'UPDATE_CHANNEL',
  EVENT_GET_MESSAGE_FROM_DATE: 'GET_MESSAGE_FROM_DATE',
  EVENT_GET_CHANNELS_FROM_DATE: 'GET_CHANNELS_FROM_DATE',
  EVENT_UPDATE_CHANNEL_MESSAGE: 'UPDATE_CHANNEL_MESSAGE',
  EVENT_SEARCH_CHANNEL: 'SEARCH_CHANNEL',
};

export const EMIT_SOCKET = {
  EMIT_SEND_MESSAGE: 'SEND_MESSAGE',
  EMIT_GET_MESSAGE: 'GET_MESSAGE',
  EMIT_JOIN_CHANNEL: 'JOIN_CHANNEL',
  EMIT_UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  EMIT_LEAVE_CHANNEL: 'LEAVE_CHANNEL',
  EMIT_UPDATE_STATUS_CHANNEL: 'UPDATE_STATUS',
  EMIT_FIND_ALL_CHANNEL: 'FIND_ALL_CHANNEL',
  EMIT_FIND_CHANNEL: 'FIND_CHANNEL',
  EMIT_JOIN_MESSAGE: 'JOIN_MESSAGE',
  EMIT_CREATE_CHANNEL: 'CREATE_CHANNEL',
  EMIT_UPDATE_STATUS: 'UPDATE_STATUS',
  EMIT_GET_MESSAGE_FROM_DATE: 'GET_MESSAGE_FROM_DATE',
  EMIT_GET_CHANNELS_FROM_DATE: 'GET_CHANNELS_FROM_DATE',
  EMIT_LIKE_CHANNEL: 'LIKE_CHANNEL',
  EMIT_SEARCH_CHANNEL: 'SEARCH_CHANNEL',
};

export const CHANNEL_SOCKET = {
  TEST_CHANNEL: 'TEST_CHANNEL',
};

export const MESSAGE = {
  SET_CHANNEL: 'SET_CHANNEL',
  ADD_MESSAGE: 'ADD_MESSAGE',
  SET_MESSAGE: 'SET_MESSAGE',
  SET_ALL_CHANNEL: 'SET_ALL_CHANNEL',
  GET_INFO_CHANNEL: 'GET_INFO_CHANNEL',
  UPDATE_CHANNEL: 'UPDATE_CHANNEL',
  RESET_DATA: 'RESET_DATA',
  TOTAL_PAGE_MESSAGES: 'TOTAL_PAGE_MESSAGES',
  RESET_ROOM: 'RESET_ROOM',
  CHECK_WON_BID: 'CHECK_WON_BID',
  LOAD_MORE_CHANNEL: 'LOAD_MORE_CHANNEL'
};

export const CAMPAIGN = {
  GET_CAMPAIGN: 'GET_CAMPAIGN'
};
